// frontend/src/routes/ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';
import { SessionExpired, CouldNotLoad } from '../components/layout/SystemState';

const ProtectedRoute = () => {
    const { status } = useAuth();
    const location = useLocation();

    if (status === 'loading') {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <CircularProgress aria-label="Loading" />
            </Box>
        );
    }

    // Signed out: sign in, then come back to this URL
    if (status === 'signedOut') {
        const back = `${location.pathname}${location.search}${location.hash}`;
        return <Navigate to={`/login?redirect_url=${encodeURIComponent(window.location.origin + back)}`} replace />;
    }

    if (status === 'expired') {
        return <SessionExpired />;
    }

    if (status === 'unreachable') {
        return <CouldNotLoad />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
